import { useState } from "react";
import { UserX } from "lucide-react";
import { toast } from "sonner";
import { api, errMsg } from "../lib/api";
import { Button } from "./ui/button";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "./ui/dialog";
import { Textarea } from "./ui/textarea";

export const CHURN_REASONS = [["pindah", "Pindah rumah / lokasi"], ["mahal", "Harga terlalu mahal"], ["sinyal", "Sinyal / koneksi buruk"], ["ganti_provider", "Pindah ke provider lain"], ["tidak_terpakai", "Jarang dipakai"], ["lainnya", "Lainnya"]];
export const churnLabel = (k) => CHURN_REASONS.find(([x]) => x === k)?.[1] || k;

export function ChurnReasonDialog({ target, onClose, onDone }) {
  const [reason, setReason] = useState(target?.current?.reason || "");
  const [note, setNote] = useState(target?.current?.note || "");
  const [busy, setBusy] = useState(false);
  if (!target) return null;
  const submit = async () => {
    setBusy(true);
    try {
      await api.post(`/routers/${target.routerId}/ppp/${encodeURIComponent(target.name)}/alasan-berhenti`, { reason, note });
      toast.success(`Alasan berhenti ${target.name} tersimpan`);
      onClose(); onDone?.();
    } catch (e) { toast.error(errMsg(e)); } finally { setBusy(false); }
  };
  return (
    <Dialog open onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-w-md" data-testid="dialog-churn-reason">
        <DialogHeader><DialogTitle className="font-heading flex items-center gap-2"><UserX className="w-5 h-5 text-rose-500" /> Alasan Pelanggan Berhenti</DialogTitle></DialogHeader>
        <div className="text-xs text-muted-foreground font-mono">{target.name}</div>
        <div className="grid grid-cols-2 gap-1.5">
          {CHURN_REASONS.map(([k, l]) => (
            <button type="button" key={k} onClick={() => setReason(k)} className={`rounded-lg border px-3 py-2 text-xs text-left transition-colors ${reason === k ? "border-rose-500 bg-rose-500/10 text-rose-500 font-semibold" : "border-border hover:bg-muted"}`} data-testid={`churn-reason-${k}`}>{l}</button>
          ))}
        </div>
        <Textarea rows={2} value={note} onChange={(e) => setNote(e.target.value)} placeholder="Catatan tambahan (opsional)" data-testid="churn-note" />
        <Button onClick={submit} disabled={busy || !reason} className="w-full bg-rose-600 hover:bg-rose-700 text-white" data-testid="churn-submit">{busy ? "Menyimpan..." : "Simpan Alasan"}</Button>
      </DialogContent>
    </Dialog>
  );
}
